import type { AdminGetLiquidityAccountsParams } from '../api'
import adminLiquidityService from './admin-liquidity.service'
import { EAdminLiquidityQueryKey } from './admin-liquidity.types'

export const adminGetLiquidityAccountsOptions = (
  params: AdminGetLiquidityAccountsParams,
) => {
  return {
    queryKey: [EAdminLiquidityQueryKey.ADMIN_LIQUIDITY_ACCOUNTS, params],
    queryFn: () => adminLiquidityService.adminGetLiquidityAccounts(params),
  }
}
